import React__default from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { StyledLoader } from './Loader.styles.js';
import getInkColour from '../../utils/getInkColour.js';
import { Spin } from '../Animations/Spin/Spin.js';

var Loader = function Loader(_ref) {
  var _ref$colour = _ref.colour,
    colour = _ref$colour === void 0 ? undefined : _ref$colour,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 1 : _ref$duration,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '1.5rem' : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading...' : _ref$label;
  var theme = useTheme();
  var providedColour = colour ? getInkColour(theme, colour) : 'currentColor';
  var loaderColour = colour === 'currentColor' ? 'currentColor' : providedColour;
  return React__default.createElement(Spin, {
    duration: duration
  }, React__default.createElement(StyledLoader, {
    "aria-label": label,
    role: "progressbar",
    "data-testid": testId,
    $colour: loaderColour,
    $size: size
  }));
};
Loader.propTypes = {
  colour: PropTypes.string,
  duration: PropTypes.number,
  label: PropTypes.string,
  size: PropTypes.string,
  testId: PropTypes.string
};

export { Loader, Loader as default };
//# sourceMappingURL=Loader.js.map
